import MyClass from './src/UmsJsSdk';

export default MyClass;
